import type {
  mutationAddTagsForEmployees,
  mutationAddTagsForEmployeesVariables,
} from 'Constants/graphql/mutations/__generated__/mutationAddTagsForEmployees'
import type {
  mutationRemoveTagsForEmployees,
  mutationRemoveTagsForEmployeesVariables,
} from 'Constants/graphql/mutations/__generated__/mutationRemoveTagsForEmployees'
import { MUTATION_ADD_TAGS_FOR_EMPLOYEES } from 'Constants/graphql/mutations/MutationAddTagsForEmployees'
import { MUTATION_REMOVE_TAGS_FOR_EMPLOYEES } from 'Constants/graphql/mutations/MutationRemoveTagsForEmployees'

import { TAG_COLOR } from 'Portal/__generated__/globalTypes'

import type { TagColor } from './tagging.types'
import { normalizeTagColor } from './tagging.utils'
import type { TaggingEntityAdapter } from './taggingEntityAdapter.types'

export const employeeTaggingAdapter = {
  add: {
    document: MUTATION_ADD_TAGS_FOR_EMPLOYEES,
    getAffectedEntityIds: (data: mutationAddTagsForEmployees) =>
      Array.from(
        new Set(
          (data.addTagsForEmployees.items ?? []).map(item =>
            String(item.taggable_id),
          ),
        ),
      ),
    operationName: 'addTagsForEmployees',
    toVariables: ({ color, entityIds, name, orgId }) => ({
      input: {
        employeeIDs: entityIds,
        orgID: orgId,
        tags: [{ color: TAG_COLOR[normalizeTagColor(color)], name }],
      },
    }),
  },
  getTagsFromHit: hit =>
    (hit['employee.tags'] ?? []).map(tag => ({
      // Typesense stores this as a string rather than the GraphQL TAG_COLOR enum.
      color: tag.color as TagColor,
      id: String(tag.id),
      name: tag.name,
    })),
  messages: {
    addError: 'EmployeeTags_add_error',
    added: 'EmployeeTags_added',
    applyingToCount: 'EmployeeTags_applying_to_count',
    removeError: 'EmployeeTags_remove_error',
    removed: 'EmployeeTags_removed',
  },
  remove: {
    document: MUTATION_REMOVE_TAGS_FOR_EMPLOYEES,
    operationName: 'removeTagsForEmployees',
    toVariables: ({ entityIds, orgId, tagIds }) => ({
      input: {
        employeeIDs: entityIds,
        orgID: orgId,
        tagIDs: tagIds,
      },
    }),
  },
  scopeSelector: '.EmployeeTagsRow',
} satisfies TaggingEntityAdapter<
  mutationAddTagsForEmployees,
  mutationAddTagsForEmployeesVariables,
  mutationRemoveTagsForEmployees,
  mutationRemoveTagsForEmployeesVariables
>
